import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 's-polaris-button',
  templateUrl: './s-polaris-button.component.html',
  styleUrls: ['./s-polaris-button.component.scss'],
  standalone: false,
})
export class PolarisButtonComponent {
  @Input() variant: 'primary' | 'secondary' = 'primary';

  @Output() pressed = new EventEmitter<void>();
}
